export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70368dce6c814bb1faa3bde7dd792e2e682b5371af&name=pushAdClickData!'